import { computed } from 'vue';
import { useLayout } from '../../layout/composables/layout';

export function useDefaultLogo() {
  const { layoutConfig } = useLayout();

  const defaultLogo = computed(() => {
    const isDark = layoutConfig.colorScheme.value === 'dark';
    return isDark ? '/layout/images/logo/contifastWhite.png' : '/layout/images/logo/contifastBlack.png';
  });

  return {
    defaultLogo
  };
}
